import { ApiCore } from '@/services/api/utils/core.js'
import { apiProvider } from '@/services/api/utils/provider.js'
import { handleError, handleResponse } from '@/services/api/utils/response.js'
import axios from 'axios'

const url = 'v1/licenseKey'
const url2 = 'v1/current-licenseKey'
const adminUrl = 'licenseKey'
const plural = 'licensekeys'
const single = 'licensekey'

const licensekeys = new ApiCore({
	index: true,
	findOne: true,
	findAll: false,
	create: true,
	update: false,
	remove: false,
	url: url,
	plural: plural,
	single: single
})

licensekeys.findOne = (parameter, _key) => {
	const licensekey = parameter.params
	return axios
		.get(`${apiProvider.BASE_URL}/${url}` + (licensekey ? `/${licensekey}` : ``))
			.then(handleResponse)
			.catch(handleError);
}
licensekeys.getOne = (_parameter, _key) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url2}`)
			.then(handleResponse)
			.catch(handleError);
}

export default licensekeys
